<template>
    <div class="child-news keep-hue">
        <div class="child-news-main" v-loading="loading"  element-loading-background="rgba(0, 0, 0, 0)">
            <div class="child-news-main-content">
                <div class="child-news-main-content-list" v-for=" (item, index) in data" key="index" @click="$emit('go-to-news-detail',item, index)">
                    <p class="child-news-main-content-list-title oneRowEllipsis">
                        {{item.title || '-'}}
                    </p>
                    <div class="child-news-main-content-list-line"></div>
                        <p class="child-news-main-content-list-desc" :class="[item.titleImage ? 'fourRowEllipsis h80' : 'elevenRowEllipsis h230'] ">{{item.contentDesc || '-'}}</p>
                        <img  v-if="item.titleImage" :src="item.titleImage.split(',')[0]" alt="资讯标题图">
                    <div class="child-news-main-content-list-bline"></div>
                    <ListFoot :data="item" class="mt8"/>
                </div>
            </div>
            <div class="pagesPag" style="display: none">
                <el-pagination
                        background
                        @current-change="handleCurrentChange"
                        :current-page="pageNo"
                        :page-size="10"
                        layout="total,prev, pager, next, jumper"
                        :total="totalCount">
                </el-pagination>
            </div>

        </div>
    </div>
</template>

<script>
    // import NoData from './noData.vue';
    import ListFoot from "./listFoot";
    export default {
        name: "childNewsCard",
        data(){
            return {
                hoverStatus: -1
            }
        },
        props: {
            data: { type: Array, default: () => []},
            columnName: { type: String, default: ''},
            loading:  { type: Boolean, default: true},
            onOffSearchMore: { type: Boolean, default: true},
            pageNo: { type: Number, default: 1},
            pageSize: { type: Number, default: 10},
            totalCount: { type: Number, default: 0},
        },
        components: {
            ListFoot
        },
        methods: {
            handleCurrentChange(pageNo){
                this.$emit('search-more',{pageNo:pageNo});
            },
        }
    }
</script>

<style scoped lang="scss" >
    .child-news {
        box-sizing: border-box;
        width: 100%;
        margin-top: 20px;
        &-main {
            min-height: calc(100vh - 250px);
            &-content {
                display: flex;
                flex-wrap: wrap;
                box-sizing: border-box;
                &-list {
                    width: 316px;
                    height: 352px;
                    padding: 20px 20px 0;
                    margin-right: 20px;
                    box-sizing: border-box;
                    background-color: #ffffff;
                    border-radius: 6px;
                    margin-top: 20px;
                    &:hover {
                        cursor: pointer;
                    }

                    &:nth-child(5n) {
                        margin-right: 0;
                    }
                    &:nth-child(4n){
                        margin-right: 20px;
                    }
                    &-title {
                        font-size: 16px;
                        height: 16px;
                        line-height: 16px;
                        color: #333333;
                    }
                    &-line {
                        width: 70px;
                        border-bottom: 1px solid #666666;
                        margin-top: 15px;
                    }
                    &-desc {
                        width: 100%;
                        margin-top: 15px;
                        font-size: 14px;
                        color: #999999;
                        line-height: 21px;

                    }
                    > img {
                        width: 100%;
                        height: 130px;
                        margin-top: 14px;
                    }
                    &-bline {
                        width: 100%;
                        border-bottom: 1px solid #E6E6E6;
                        margin-top: 14px;

                    }
                    .h80 {
                        height: 80px;
                    }
                    .h230 {
                        height: 230px;
                    }
                }

            }
            .pagesPag {
                margin-top: 20px;
                background-color: white;
                border-radius: 2px;
                padding: 20px;
            }


        }


    }
    @media (max-width: 1719px){
        .child-news-main-content-list {
            width: 290px;
            &:nth-child(5n){
                margin-right: 20px;
            }
            &:nth-child(4n){
                margin-right: 0;
            }
        }


    }



</style>